export default __webpack_public_path__ + "static/media/problema-01.df62553d.webp";